// extracted by mini-css-extract-plugin
module.exports = {"upload_container":"BulkCreateTabFeature_upload_container__1aCgw","printer_options_container":"BulkCreateTabFeature_printer_options_container__1m13T"};